import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarInitialsComponent } from '@libs/ui-lib';
import { BaaRequest } from '../baa-request-flow.service';

@Component({
  selector: 'lib-baa-request-list-items',
  standalone: true,
  imports: [SvgIconComponent, TranslatePipe, AvatarInitialsComponent],
  templateUrl: './baa-request-list-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaRequestListItemsComponent {
  public readonly requests = input.required<BaaRequest[]>();
  public readonly isActionLoading = input<boolean>(false);
  public readonly approve = output<string>();
  public readonly deny = output<string>();

  protected readonly hasRequests = computed(() => this.requests().length > 0);
}
